// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I_VZ","footer":"styles_footer__Ryoo7"};